import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  openFormModal,
  setSearch,
  setTalentoFilter,
  clearFilters,
} from "../../../store/reducers/seleccionAplicacion/actividades-aplicacion-plantel/ActividadesAplicacionPlantel.reducer";
import SearchInput from "../../UI/SearchInput";
import Select2 from "../../UI/Select2";
import { getTalentosSelectoresPlantelService } from "../../../services/planteles/talentosPlantel.service";

const ActividadesAplicacionHeaderPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { search, talentoFilter } = useSelector(
    (state) => state.actividadesAplicacionPlantel,
  );

  const fetchTalentos = async (searchTerm) => {
    const response = await getTalentosSelectoresPlantelService(
      plantelId,
      searchTerm,
    );
    return response.map((item) => ({ id: item.id, label: item.label }));
  };

  const hasFilters = search || talentoFilter;

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold text-center text-md-start">
            Actividades de aplicación
          </h5>
        </div>

        <div className="col-12 col-md">
          <div className="d-flex flex-column gap-2">
            {/* Buscador + botón nueva */}
            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end">
              <SearchInput
                value={search}
                onChange={(value) => dispatch(setSearch(value))}
                placeholder="Buscar actividades..."
                minChars={3}
                className="flex-grow-1"
              />
              <button
                onClick={() => dispatch(openFormModal({ mode: "create" }))}
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2 radius-8"
                style={{ height: "44px", minWidth: "160px" }}
              >
                <Icon icon="mdi:plus" width="20" />
                <span className="d-none d-sm-inline fw-medium">
                  Nueva actividad
                </span>
                <span className="d-inline d-sm-none fw-medium">Nueva</span>
              </button>
            </div>

            {/* Filtro talento */}
            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end align-items-sm-end">
              <div style={{ minWidth: "200px", maxWidth: "300px" }}>
                <Select2
                  value={talentoFilter}
                  onChange={(value) => dispatch(setTalentoFilter(value || ""))}
                  fetchOptions={fetchTalentos}
                  placeholder="Filtrar por talento..."
                  isClearable
                />
              </div>

              {hasFilters && (
                <button
                  onClick={() => dispatch(clearFilters())}
                  className="btn btn-outline-secondary d-flex align-items-center gap-1"
                  style={{ height: "44px" }}
                  title="Limpiar filtros"
                >
                  <Icon icon="mdi:filter-remove-outline" width="18" />
                  <span className="d-none d-sm-inline">Limpiar</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActividadesAplicacionHeaderPlantel;
